export default __webpack_public_path__ + "static/media/googlePlay.94ad53d4.svg";